// extracted by mini-css-extract-plugin
module.exports = {"carousel-container":"glide-slider-m__carousel-container__1k5_n","image-element":"glide-slider-m__image-element__D9AA2"};